import BaseButton, { ButtonProps as BaseButtonProps } from 'carbon-react/lib/components/button';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { EnhancedButtonType, useEnhancedButtonType } from '../hooks';

const defaultStyle = css``;
const embeddedStyle = css`
  min-height: 32px;
`;

type ButtonTypes = NonNullable<BaseButtonProps['buttonType']>;

const StyledButton = styled(BaseButton)`
  ${({ theme }) => (theme.name === 'SIT-Embeded' ? embeddedStyle : defaultStyle)}
`;

export interface ButtonProps extends Omit<BaseButtonProps, 'buttonType'> {
  buttonType?: EnhancedButtonType<ButtonTypes>;
  tabIndex?: number;
}

const Button = forwardRef<HTMLButtonElement, ButtonProps & React.RefAttributes<HTMLButtonElement>>(function Button(
  { buttonType: enhancedButtonType, ...props },
  ref,
) {
  const buttonType = useEnhancedButtonType(enhancedButtonType);
  return <StyledButton ref={ref} buttonType={buttonType} {...props} />;
});

export default Button;
